import React from 'react';
import {motion} from "framer-motion"
import {fadeIn} from '../variants'
import blogApp from '../assets/blog-app.jpg'
import restau from '../assets/restoration-app.jpg'
import chatApp from '../assets/chat-app.jpg'

const Work = () => {
  return (<div id='work' className='section lg:mt-60'>
      <div className='container mx-auto'>
        <div className='flex flex-col lg:flex-row lg:items-center gap-x-10'>
          <div className='flex-1 flex flex-col gap-y-12 mb-10 lg:mb-0 lg:justify-center '>
            {/* text */}
            <div>
              <h2 className='h2 leading-tight text-accent'> 
                My Latest <br />
                Work.
              </h2>
              <p className='max-w-sm mb-4'>
              Academic and personal projects you have created during your apprenticeship
              </p>
              <a href='https://github.com/dahhou-ilyas?tab=repositories' className='btn btn-sm cv w-[44%] l lg:w-[30%]'>View all projects</a>
            </div>
            {/* image */}
            <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
              {/* over lay */}
              <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
              {/* image */}
              <img className='group-hover:scale-125 translate-all duration-500' src={blogApp} alt=''/>
              {/* pretitle */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                <span className='text-white'>
                  Fullstack
                </span>
              </div>
              {/* title */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                <span className='text-3xl text-white '>Blog Application Project</span>
              </div>
            </div>
          </div>
          <motion.div variants={fadeIn('left',0.1)} 
                    initial='hidden' whileInView={"show"} 
                    viewport={{once:false,amount:0.7}} className='flex-1 flex flex-col gap-y-4'>
            {/* images */}
            <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
              {/* over lay */}
              <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
              {/* image */}
              <img className='group-hover:scale-125 translate-all duration-500' src={chatApp} alt=''/>
              {/* pretitle */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                <span className='text-white'>
                  Socket.Io
                </span>
              </div>
              {/* title */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                <span className='text-3xl text-white '>Chat Application Project</span>
              </div>
            </div>
            {/* images */}
            <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
              {/* over lay */}
              <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
              {/* image */}
              <img className='group-hover:scale-125 translate-all duration-500' src={restau} alt=''/>
              {/* pretitle */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                <span className='text-white'>
                  Fullstack
                </span>
              </div>
              {/* title */}
              <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-700 z-50'>
                <span className='text-3xl text-white '>Restaurant Reservation Application</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>);
};

export default Work;
